import SignupCompanyTemplate from './sign-up-company-template';

export default SignupCompanyTemplate;
